import { assertCanHandle } from '@lucidlink/tscore';
import { Logging } from '#common/logging';
import { SECOND_MS } from '#common/time';
import { canHandleAllErrors } from '#common/util';
const DEFAULT_USER_ACTIVITY_THRESHOLD_MS = 30 * SECOND_MS;
export class UserActivityTracker {
    nodeId;
    principalName;
    metaStore;
    keyValueHelpers;
    log = Logging.getLogger('UserActivityTracker');
    thresholdMs = DEFAULT_USER_ACTIVITY_THRESHOLD_MS;
    persistedTime = 0n;
    constructor(nodeId, principalName, metaStore, keyValueHelpers) {
        this.nodeId = nodeId;
        this.principalName = principalName;
        this.metaStore = metaStore;
        this.keyValueHelpers = keyValueHelpers;
    }
    setThreshold(thresholdMs) {
        this.thresholdMs = thresholdMs;
    }
    async track() {
        const currentTime = BigInt(Date.now());
        const elapsedTime = currentTime - this.persistedTime;
        if (elapsedTime < this.thresholdMs) {
            return;
        }
        try {
            const activityKeyValue = this.keyValueHelpers.makeUserActivityRecord(this.principalName, this.nodeId, currentTime);
            await this.metaStore.commitKeyValuePairs([activityKeyValue], true);
            this.persistedTime = currentTime;
        }
        catch (err) {
            assertCanHandle(err, canHandleAllErrors);
            this.log.warn({ errorMessage: err }, `Failed to update last active time for user ${this.principalName}`);
        }
    }
}
